import { render, staticRenderFns } from "./ScrollToAccessories.vue?vue&type=template&id=b8aa1326"
import script from "./ScrollToAccessories.vue?vue&type=script&lang=js"
export * from "./ScrollToAccessories.vue?vue&type=script&lang=js"
import style0 from "./ScrollToAccessories.vue?vue&type=style&index=0&id=b8aa1326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports